import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    menu: null,
    selectedDomain: null,
    selectedProcess: null,
    selectedSubProcess: null
}

const menuSlice = createSlice({
    name: "menu",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            localStorage.setItem('user', null);
            Object.assign(state, initialState);
         })
    },
    reducers:{
        storeMenu: (state, action) => {
            state.menu= action.payload;
        },
        saveSelectedDomainToStore: (state, action) => {
            state.selectedDomain = action.payload;
        },
        saveSelectedProcessToStore: (state, action) => {
            state.selectedProcess = action.payload;
        },
        saveSelectedSubProcessToStore: (state, action) => {
            state.selectedSubProcess = action.payload;
        }
    }
})

export const { storeMenu, saveSelectedDomainToStore, saveSelectedSubProcessToStore, saveSelectedProcessToStore } = menuSlice.actions
export default menuSlice.reducer